import React from "react";
import { Icon } from "@iconify/react";
import Button from "../../Components/Button";
import { Typography } from "../../Components/Typography";

const CheckRow = ({ label, checked, onChange, extra }) => (
  <label className="flex items-center gap-3 rounded-lg border border-slate-100 bg-white px-3 py-2.5 cursor-pointer">
    <input
      type="checkbox"
      checked={Boolean(checked)}
      onChange={(e) => onChange(e.target.checked)}
      className="h-4 w-4 rounded border-slate-300 text-violet-600"
    />
    <Typography as="p" className="text-sm text-slate-800 flex-1">
      {label}
    </Typography>
    {extra}
  </label>
);

const EditablePitchPreparation = ({ formValues, onFieldChange, onSave, saving, hideSaveButton = false }) => (
  <div className="flex flex-col gap-6">
    <div>
      <Typography as="h3" className="text-lg font-bold text-slate-900">
        Pitch preparation
      </Typography>
      <Typography as="p" className="text-sm text-slate-500 mt-1">
        Track checklist items and links for your final pitch.
      </Typography>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="rounded-xl border border-slate-200 p-5 flex flex-col gap-3">
        <Typography as="h4" className="text-sm font-bold text-slate-800">
          Investor pitch
        </Typography>
        <CheckRow
          label="Problem statement"
          checked={formValues.investor_pitch_problem_statement}
          onChange={(v) => onFieldChange("investor_pitch_problem_statement", v)}
        />
        <CheckRow
          label="Product market fit"
          checked={formValues.investor_pitch_product_market_fit}
          onChange={(v) => onFieldChange("investor_pitch_product_market_fit", v)}
        />
        <CheckRow
          label="Customer profile"
          checked={formValues.investor_pitch_customer_profile}
          onChange={(v) => onFieldChange("investor_pitch_customer_profile", v)}
        />
        <CheckRow
          label="Competitive landscape"
          checked={formValues.investor_pitch_competitive_landscape}
          onChange={(v) => onFieldChange("investor_pitch_competitive_landscape", v)}
        />
        <CheckRow
          label="Target addressable market"
          checked={formValues.investor_pitch_target_addressable_market}
          onChange={(v) => onFieldChange("investor_pitch_target_addressable_market", v)}
        />
      </div>

      <div className="rounded-xl border border-slate-200 p-5 flex flex-col gap-3">
        <Typography as="h4" className="text-sm font-bold text-slate-800">
          Traction & metrics
        </Typography>
        <CheckRow
          label="Revenue"
          checked={formValues.market_traction_revenue}
          onChange={(v) => onFieldChange("market_traction_revenue", v)}
        />
        <CheckRow
          label="Margin"
          checked={formValues.market_traction_margin}
          onChange={(v) => onFieldChange("market_traction_margin", v)}
        />
        <CheckRow
          label="Sales"
          checked={formValues.metrics_sales}
          onChange={(v) => onFieldChange("metrics_sales", v)}
        />
        <CheckRow
          label="Pipeline"
          checked={formValues.metrics_pipeline}
          onChange={(v) => onFieldChange("metrics_pipeline", v)}
        />
        <CheckRow
          label="Marketing"
          checked={formValues.metrics_marketing}
          onChange={(v) => onFieldChange("metrics_marketing", v)}
        />
        <CheckRow
          label="Followers"
          checked={formValues.metrics_followers}
          onChange={(v) => onFieldChange("metrics_followers", v)}
        />
        <CheckRow
          label="Customer acquisition cost"
          checked={formValues.metrics_customer_acquisition_cost}
          onChange={(v) => onFieldChange("metrics_customer_acquisition_cost", v)}
        />
      </div>
    </div>

    <div className="rounded-xl border border-slate-200 p-5 flex flex-col gap-3">
      <Typography as="h4" className="text-sm font-bold text-slate-800">
        Product / video link
      </Typography>
      <input
        type="url"
        value={formValues.product_video_link || ""}
        onChange={(e) => onFieldChange("product_video_link", e.target.value)}
        placeholder="https://..."
        className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-200"
      />
    </div>

    {!hideSaveButton && (
      <div className="flex justify-end pt-2 border-t border-slate-100">
        <Button
          variant="primary"
          onClick={onSave}
          disabled={saving}
          className="bg-violet-600 hover:bg-violet-700"
          startIcon={
            saving ? (
              <Icon icon="lucide:loader-2" className="h-4 w-4 animate-spin" />
            ) : (
              <Icon icon="lucide:save" className="h-4 w-4" />
            )
          }
        >
          {saving ? "Saving..." : "Save changes"}
        </Button>
      </div>
    )}
  </div>
);

export default EditablePitchPreparation;
